import { StyleSheet } from 'react-native';

import { colors } from '../../colors';
import { GRID_PADDING_TOP } from './RoomLayoutGrid.styles';

const ROW_PADDING_VERTICAL = 4;
const GAP_TO_GRID = 24;

/** Left/right padding of the chip row; used to align the active chip flush to the left edge. */
export const ROW_PADDING_HORIZONTAL = 4;

export const styles = StyleSheet.create({
  chip: {
    alignItems: 'center',
    backgroundColor: colors.legendCardBg,
    borderColor: colors.legendBookedBorder,
    borderRadius: 12,
    borderWidth: 2,
    flexDirection: 'row',
    height: 50,
    justifyContent: 'flex-start',
    minWidth: 132,
    paddingHorizontal: 16,
    paddingVertical: 8
  },
  chipActive: {
    borderColor: colors.legendSelectedBorder
  },
  chipError: {
    borderColor: colors.legendErrorBorder
  },
  chipLabel: {
    color: colors.legendText,
    fontSize: 14,
    fontWeight: '400'
  },
  chipLabelError: {
    color: colors.legendErrorText
  },
  chipSpotLabel: {
    color: colors.legendSelectedText,
    fontSize: 14,
    fontWeight: '600',
    marginLeft: 12
  },
  chipWithSpot: {
    justifyContent: 'space-between'
  },
  container: {
    marginBottom: GAP_TO_GRID - ROW_PADDING_VERTICAL - GRID_PADDING_TOP
  },
  row: {
    flexDirection: 'row',
    gap: 12,
    paddingHorizontal: ROW_PADDING_HORIZONTAL,
    paddingVertical: ROW_PADDING_VERTICAL
  }
});
